import PropTypes from 'prop-types';
import { accountShape } from '../account';
import { assetShape } from '../asset';

const activityShape = PropTypes.shape({
  activityId: PropTypes.string,
  config: PropTypes.object,
  activityTheme: PropTypes.string,
  plugin: PropTypes.object,
  creator: accountShape,
  parentPathwayId: PropTypes.string,
  childrenPathways: PropTypes.arrayOf(PropTypes.string),
  components: PropTypes.arrayOf(PropTypes.string),
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  assets: PropTypes.arrayOf(assetShape),
});

export {
  activityShape,
};
